(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ma-offre-compteur"] && !Shopify.designMode) return;
  try {
    (function () {
  var RAFRAICHISSEMENT_SR = 60000; // resume lecteur d'ecran : 1 min

  // UN SEUL minuteur pour toute la page. Chaque compteur rendu s'inscrit dans
  // ce registre ; le battement unique les rafraichit tous. Le minuteur n'existe
  // que tant que le registre est non vide et que l'onglet est visible.
  var instances = [];
  var timer = null;

  function deuxChiffres(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function demarrer() {
    if (timer !== null) return;
    if (instances.length === 0) return;
    if (document.visibilityState === 'hidden') return;
    timer = window.setInterval(battement, 1000);
  }

  function arreter() {
    if (timer === null) return;
    window.clearInterval(timer);
    timer = null;
  }

  function battement() {
    var maintenant = Date.now();
    for (var i = instances.length - 1; i >= 0; i--) {
      if (!rafraichir(instances[i], maintenant)) instances.splice(i, 1);
    }
    if (instances.length === 0) arreter();
  }

  function terminer(inst) {
    var racine = inst.racine;
    var message = racine.dataset.labelExpire || '';
    if (inst.resume) inst.resume.textContent = message;
    if (message && racine.parentNode) {
      var p = document.createElement('p');
      p.className = 'ma-offre__expire';
      p.textContent = message;
      racine.parentNode.replaceChild(p, racine);
    } else {
      // On RETIRE le noeud au lieu de poser l'attribut hidden : la regle
      // navigateur [hidden] { display: none } est battue par le display: flex
      // de .ma-offre__compteur, et le compteur restait affiche, fige sur ses
      // dernieres valeurs, pour un visiteur ayant la page ouverte au moment
      // de l'echeance.
      retirer(racine);
    }
  }

  function retirer(racine) {
    if (racine.remove) {
      racine.remove();
    } else if (racine.parentNode) {
      racine.parentNode.removeChild(racine);
    }
  }

  function rafraichir(inst, maintenant) {
    // Un compteur detache du document (rechargement de section dans l'editeur)
    // sort du registre de lui-meme : aucun minuteur ne survit a son DOM.
    if (!inst.racine.isConnected) return false;

    var reste = inst.cible - maintenant;
    if (reste <= 0) {
      terminer(inst);
      return false;
    }

    var secondes = Math.floor(reste / 1000);
    var jours = Math.floor(secondes / 86400);
    var heures = Math.floor((secondes % 86400) / 3600);
    var minutes = Math.floor((secondes % 3600) / 60);
    var sec = secondes % 60;

    inst.jours.textContent = deuxChiffres(jours);
    inst.heures.textContent = deuxChiffres(heures);
    inst.minutes.textContent = deuxChiffres(minutes);
    inst.secondes.textContent = deuxChiffres(sec);

    if (inst.resume && maintenant - inst.dernierResume > RAFRAICHISSEMENT_SR) {
      inst.dernierResume = maintenant;
      inst.resume.textContent =
        inst.jours.textContent + ' ' + inst.legende + ' ' +
        inst.heures.textContent + ' ' + inst.legendeHeures;
    }

    return true;
  }

  function inscrire(racine) {
    if (racine.dataset.maInit === '1') return;
    racine.dataset.maInit = '1';

    var cible = new Date(racine.dataset.end).getTime();
    if (isNaN(cible)) {
      // Date mal saisie dans l'editeur : on retire le compteur plutot que
      // d'afficher « NaN » au client.
      retirer(racine);
      return;
    }

    var legendes = racine.querySelectorAll('.ma-offre__legende');
    var inst = {
      racine: racine,
      cible: cible,
      jours: racine.querySelector('[data-ma-jours]'),
      heures: racine.querySelector('[data-ma-heures]'),
      minutes: racine.querySelector('[data-ma-minutes]'),
      secondes: racine.querySelector('[data-ma-secondes]'),
      resume: racine.parentNode ? racine.parentNode.querySelector('[data-ma-resume]') : null,
      legende: legendes[0] ? legendes[0].textContent : '',
      legendeHeures: legendes[1] ? legendes[1].textContent : '',
      dernierResume: 0
    };

    if (!inst.jours || !inst.heures || !inst.minutes || !inst.secondes) return;

    // Premier rendu immediat : pas de « -- » visible le temps du premier tick.
    if (rafraichir(inst, Date.now())) {
      instances.push(inst);
      demarrer();
    }
  }

  function inscrireTous(portee) {
    var racine = portee || document;
    var noeuds = racine.querySelectorAll('[data-ma-compteur]');
    for (var i = 0; i < noeuds.length; i++) inscrire(noeuds[i]);
  }

  function elaguer() {
    for (var i = instances.length - 1; i >= 0; i--) {
      if (!instances[i].racine.isConnected) instances.splice(i, 1);
    }
    if (instances.length === 0) arreter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { inscrireTous(); });
  } else {
    inscrireTous();
  }

  // Editeur de theme : reinscription apres rechargement d'une section.
  document.addEventListener('shopify:section:load', function (e) { inscrireTous(e.target); });
  document.addEventListener('shopify:section:unload', elaguer);

  // Onglet masque : aucun minuteur ne tourne. Au retour, rattrapage immediat.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      arreter();
    } else {
      battement();
      demarrer();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
